import { Pipe, PipeTransform } from '@angular/core';

interface DeliveryLocationObject {
  country?: string;
  province?: string;
  commune?: string;
  deliverAt?: string;
  addressType?: string;
  [key: string]: any;
}

@Pipe({
  name: 'deliveryLocation'
})
export class DeliveryLocationPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return 'N/A';
    }

    let loc: DeliveryLocationObject | null = null;

    if (typeof value === 'string') {
      // Try to parse JSON string first
      const trimmed = value.trim();
      if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
        try {
          const parsed = JSON.parse(trimmed);
          if (parsed && typeof parsed === 'object') {
            loc = parsed as DeliveryLocationObject;
          }
        } catch (_) {
          // Not parsable JSON, fall back to raw string
          return value;
        }
      } else {
        // Plain string (already formatted or free text)
        return value;
      }
    } else if (typeof value === 'object') {
      loc = value as DeliveryLocationObject;
    }

    if (!loc) return 'N/A';

    const parts: string[] = [];
    if (loc.deliverAt) parts.push(loc.deliverAt);
    if (loc.commune) parts.push(loc.commune);
    if (loc.province) parts.push(loc.province);
    if (loc.country) parts.push(loc.country);

    return parts.length ? parts.join(', ') : 'N/A';
  }
}


